
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/mock-server",
      function () {
        return require("private-next-pages/core-exchange/docs/mock-server.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/mock-server"])
      });
    }
  